const ferries = {
  ferry: "Traghetto", // translated
  ferries: "Traghetti", // translated
  selectOriginPort: "Seleziona la porta di origine", // translated
  selectDestPort: "Seleziona il porto di destinazione", // translated
  continue: "Continua", // translated
  viewTimetables: "Visualizza gli orari", // translated
  operator: "Operatore", // translated
  cabin: "Cabina", // translated
  cabins: "Cabine", // translated
  place: "Posto", // translated
  places: "Luoghi", // translated
  seat: "Posto a sedere", // translated
  seats: "Sedili", // translated
  seating: "Posti a sedere", // translated
  deckSpace: "Spazio sul ponte", // translated
  compulsory: "obbligatorio", // translated
  departure: "Partenza", // translated
  total: "Totale", // translated
  back: "Indietro", // translated
  next: "Prossimo", // translated
  duration: "Durata", // translated
  return: "Ritorno", // translated
  prebook: "Prenota in anticipo", // translated
  travelInfo: "Informazioni di viaggio", // translated
  book: "Libro", // translated
  adults: "Adulti", // translated
  child: "Bambino", // translated
  seniors: "Gli anziani", // translated
  senior: "Anziano", // translated
  to: "A", // translated
  passenger: "Passeggeri", // translated
  details: "Dettagli", // translated
  currencyForTickets: "La valuta per questi biglietti sarà", // translated
  seatsError: "Il numero di passeggeri non è uguale alla capacità.", // translated
  title: "Titolo", // translated
  firstName: "Nome di battesimo", // translated
  lastName: "Cognome", // translated
  email: "E-mail", // translated
  phone: "Telefono", // translated
  dateOfBirth: "Data di nascita", // translated
  placeOfBirth: "Luogo di nascita", // translated
  groupLeader: "Capo del gruppo", // translated
  isRequired: "È obbligatorio", // translated
  charactersOnly: "Solo personaggi", // translated
  latinCharactersAndSpacesOnly: "Solo caratteri latini e spazi", // translated
  validEmail: "Non è un'e-mail valida", // translated
  atLeastOneAdult: "È richiesto almeno 1 adulto.", // translated
  atLeastOneSenior: "È richiesto almeno 1 senior.", // translated
  toastAlert: "Si prega di correggere tutti gli errori nei moduli sottostanti.", // translated
  backToFerriesList: "Torna all'elenco dei traghetti", // translated
  bestPrice: "Miglior prezzo", // translated
  fastest: "Il più veloce", // translated
  beforeDeparture: "Prima della partenza", // translated
  perPerson: "A testa", // translated
  notAvailableForOnlineBooking: "Non disponibile per la prenotazione online", // translated
  hurryLimitedAvailability: "Affrettarsi! Disponibilità limitata", // translated
  berth: "Ormeggio", // translated
  berths: "Posti letto", // translated
  sumOfSelectionNotEqualToPersons: "La somma della tua selezione non è uguale al numero di passeggeri", // translated
  attemptToBook: "Hai tentato di prenotare un totale di", // translated
  seatsWhenYouHave: "posti quando ne hai", // translated
  passengersTravelling: "passeggeri in viaggio", // translated
  withReturn: "con biglietti di andata e ritorno", // translated
  pleaseCorrectYourSelection: "Correggi la tua selezione", // translated
  pleaseSelectUpTo: "Seleziona fino a", // translated
  accommodationTypes: "tipologie di alloggio", // translated
  selectionPrices: "Prezzi di selezione", // translated
  yourCurrentTicket: "Il tuo attuale tipo di biglietto è", // translated
  upgradeTo: "L'aggiornamento a", // translated
  wouldYouLikeToUpgrade: "Desideri aggiornare la tipologia del tuo biglietto?", // translated
  backToTicketTypes: "Torna alle tipologie di biglietti", // translated
  originPort: "Porto di origine", // translated
  destinationPort: "Porto di destinazione", // translated
  outboundDate: "Data di uscita", // translated
  inboundDate: "Data di entrata", // translated
  passengers: "Passeggeri", // translated
  hasReturn: "Ha Ritorno", // translated
  passportNumber: "Numero di passaporto", // translated
  passportExpiryDate: "data di scadenza del passaporto", // translated
  passportPlaceOfIssue: "Luogo di rilascio del passaporto", // translated
  passportStartDate: "Data di inizio del passaporto", // translated
  cityCode: "Codice della città", // translated
};

export default ferries;
